import "../Styles/mouse.css"

function Mouse() {
    return (
        <div className="about-me__mouse-scroll-cont">
            <div className="mouse"></div>
        </div>
    );
}

export default Mouse;